import { ConfigurableColumns } from '@/components/ConfigurableColumns';
import { GenericDateFunctionField } from '@/components/GenericDateFunctionField';
import { Chip } from '@mui/material';
import { FunctionField, ReferenceField } from 'react-admin';

export const columns: ConfigurableColumns[] = [
  {
    label: 'ID',
    source: 'id',
    sortable: true,
  },
  {
    label: 'Timestamp',
    source: 'when',
    sortable: true,
    GridComponent: GenericDateFunctionField,
    exportFn: record => record.when?.toString(),
  },
  {
    label: 'Type',
    source: 'type',
  },
  {
    label: 'Reason',
    source: 'reason',
  },
  {
    label: 'User Type',
    source: 'userMetadata.type',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) => {
        const userType = record.userMetadata?.type;
        let chipColor = 'default';

        if (userType === 'admin') {
          chipColor = 'secondary'; // purple
        } else if (userType === 'therapist') {
          chipColor = 'primary'; // blue
        } else if (userType === 'patient') {
          chipColor = 'success'; // green
        }

        return userType ? (
          <Chip
            label={userType}
            color={
              chipColor as
                | 'default'
                | 'primary'
                | 'secondary'
                | 'success'
            }
            size="small"
          />
        ) : null;
      },
    },
  },
  {
    label: 'User',
    source: 'userMetadata.id',
    exportFn: record => record.userMetadata?.id,
    sortable: false,
    GridComponent: props => (
      <FunctionField
        {...props}
        render={(record: any) => {
          if (record.userMetadata?.type === 'therapist') {
            // console.log(
            //   "RETURNING REFERENCE FIELD 😵‍💫😵‍💫😵‍💫😵‍💫😵‍💫",
            //   record.userMetadata
            // );

            return (
              <ReferenceField
                reference="therapists"
                record={{ id: record.userMetadata?.id }}
                source="id"
              >
                <FunctionField
                  render={(record: any) =>
                    `${record.title ? `${record.title} ` : ''}${
                      record.firstName
                    } ${record.lastName}`
                  }
                />
              </ReferenceField>
            );
          } else {
            console.log(
              'RETURNING RAW 😵‍💫😵‍💫😵‍💫😵‍💫😵‍💫',
              record.userMetadata,
            );

            return record.userMetadata?.id;
          }
        }}
      />
    ),
  },
  {
    label: 'Op Type',
    source: 'crudOperation.op',
  },
  {
    label: 'Collection',
    source: 'crudOperation.type',
    sortable: true,
  },
  {
    label: 'Document ID',
    source: 'crudOperation.id',
    // sortable: true,
    // GridComponent: CopiableIdDataGridField,
  },
  {
    label: 'Duration (ms)',
    source: 'duration',
    sortable: true,
  },
  {
    label: 'Result',
    source: 'result',
    sortable: true,
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) => (
        <Chip
          label={record.result}
          color={record.result === 'success' ? 'success' : 'error'}
          size="small"
        />
      ),
    },
  },
  {
    label: 'Error',
    source: 'error',
    sortable: false,
  },
  {
    label: 'Next Status',
    source: 'nextStatus',
    sortable: false,
  },
];
